<div class="card">
  <div class="grid">
    <div class="col-12 font-medium text-xl text-600 mb-3">
      Detallar Documento
    </div>
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12 md:col-4">
            <label>Tipo de documento</label>
            <p-dropdown
              [options]="documentsType"
              formControlName="documentType"
              placeholder="Seleccionar tipo de documento"
              [itemSize]="2"
            >
            </p-dropdown>
          </div>
          <div class="field col-12 md:col-8">
            <label>Comprobante</label>
            <input
              pInputText
              formControlName="documentCode"
              type="text"
              [ngClass]="{ 'ng-dirty': fg.get('documentCode').invalid }"
            />
            <div
              class="p-invalid"
              *ngIf="
                fg.get('documentCode').invalid &&
                (fg.get('documentCode').dirty || fg.get('documentCode').touched)
              "
            >
              <div *ngIf="fg.get('documentCode').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('documentCode').errors?.notFactura">
                <small class="p-error"
                  >El campo debe tener el patron FABC-9999999 </small
                >
              </div>
              <div *ngIf="fg.get('documentCode').errors?.notBoleta">
                <small class="p-error"
                  >El campo debe tener el patron B999-9999999</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Fecha de facturación</label>
            <input pInputText formControlName="date" type="date" />
          </div>
          <div class="field col-12 md:col-6">
            <label>Hora de facturación</label>
            <input pInputText formControlName="time" type="time" />
          </div>
          <div class="field col-12 md:col-6"></div>

          <div class="field col-12 md:col-3">
            <button
              pButton
              pRipple
              label="Anterior"
              (click)="prevPage()"
              icon="pi pi-angle-left"
              iconPos="left"
            ></button>
          </div>
          <div class="field col-12 md:col-3">
            <button
              pButton
              pRipple
              label="Siguiente"
              (click)="nextPage()"
              [disabled]="fg.invalid"
              icon="pi pi-angle-right"
              iconPos="right"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
